import React, { useContext, useState } from "react";
import { AuthContext } from "../../../../contexts/AuthProvider";
import AccountProfile from "./AccountPages/AccountProfile";
import PoliciesTaxes from "./AccountPages/PoliciesTaxes";

const MyAccount = () => {
  const { user, logout } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState(1);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  return (
    <div className="min-h-screen bg-gray-50 pb-20 font-sans">
  {/* Header: Refined White Surface */}
  <header className="w-full bg-white border-b border-gray-200 pt-12 pb-8 px-8">
    <div className="max-w-screen-xl mx-auto">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4">
        <div className="space-y-2">
          {/* Breadcrumb style label */}
          <span className="text-[10px] font-black tracking-[0.2em] text-blue-600 uppercase bg-blue-50 px-3 py-1 rounded-full">
            System Settings
          </span>
          <h1 className="text-4xl font-extrabold tracking-tight text-gray-900">
            MY COLOR <span className="text-gray-400 font-light">EVENTS</span>
          </h1>
          <div className="flex items-center gap-2 group">
            <div className="p-1.5 bg-gray-100 rounded-lg group-hover:bg-blue-100 transition-colors">
              <svg className="w-4 h-4 text-gray-500 group-hover:text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
            </div>
            <p className="text-sm font-medium text-gray-600 truncate">{user?.email}</p>
          </div>
        </div>

        {/* Tab Navigation: Borderless Pill Style */}
        <nav className="flex items-center gap-1 bg-gray-100 p-1 rounded-2xl border border-gray-200">
          {[
            { id: 1, label: "Profile" },
            { id: 2, label: "Policies & Taxes" },
            { id: 3, label: "All Users" }
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => handleTabClick(tab.id)}
              className={`px-6 py-2.5 text-xs font-bold uppercase tracking-widest rounded-xl transition-all duration-200 ${
                activeTab === tab.id
                  ? "bg-white text-blue-600 shadow-sm ring-1 ring-gray-200"
                  : "text-gray-500 hover:text-gray-900 hover:bg-gray-200/50"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </nav>
      </div>
    </div>
  </header>

  {/* Main Content: Floating Card Layout */}
  <main className="max-w-screen-xl mx-auto px-6 -mt-4 relative z-10">
    <div className="bg-white border border-gray-200 rounded-[2.5rem] shadow-[0_10px_40px_-15px_rgba(0,0,0,0.05)] overflow-hidden">
      
      {/* Content Padding */}
      <div className="p-8 md:p-12">
        {activeTab === 1 && (
          <div className="animate-in fade-in slide-in-from-top-4 duration-500">
            <AccountProfile />
          </div>
        )}
        
        {activeTab === 2 && (
          <div className="animate-in fade-in slide-in-from-top-4 duration-500">
            <PoliciesTaxes />
          </div>
        )}
        
        {activeTab === 3 && (
          <div className="flex flex-col items-center justify-center py-20 text-center animate-in zoom-in-95 duration-500">
             <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4">
                <svg className="w-8 h-8 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 005.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/></svg>
             </div>
             <h3 className="text-gray-900 font-bold uppercase tracking-widest text-sm">User Directory</h3>
             <p className="text-gray-500 text-sm mt-1 max-w-xs">Management tools for all registered accounts will appear here.</p>
          </div>
        )}
      </div>
    </div>

    {/* Footer Detail */}
    <div className="mt-8 text-center">
        <p className="text-[10px] text-gray-400 font-bold uppercase tracking-[0.3em]">
          &copy; 2026 My Color Events & Design System
        </p>
    </div>
  </main>
</div>
  );
};

export default MyAccount;
